<div class="wrapper-upload-form" ng2FileDrop [uploader]="uploader">
  <ng-content></ng-content>
  <div class="dropZone">
    <div class="well my-drop-zone one-task-drop-zone">
      <ng-container *irisIfLoaded="!uploading(); loaderType: 'fill'">
        <div>
          <span class="me-2">{{ 'label.DropFilesHereOr' | translate }}</span>
          <label class="add-entry" [style.cursor]="disabled() ? 'default' : 'pointer'">
            <i class="fas fa-upload"></i>
            {{ 'label.ClickToUpload' | translate }}
            <input [disabled]="disabled()" type="file" ng2FileSelect [uploader]="uploader" [accept]="accept()" multiple/>
          </label>
        </div>
        <p>{{'text.dms.MaxFileSize' | translate:{maxSize: maxFileSize} }}</p>
      </ng-container>
    </div>
  </div>
</div>
